import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _displayComponentProp;
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import { DEFAULT_LABEL } from './WebsiteComponentInteraction.constants';
import { DisplayComponentPropsMapPropType } from './WebsiteComponentInteraction.proptypes';
import { getDisplayComponent, getDisplayComponentProps } from './WebsiteComponentInteraction.utils';
import { WebsiteComponentInteractionPropType, ChildrenPropType } from '../../../../services/proptypes';
import { EventPropType } from '../../../analytics/types';
import { INTERACTION_DISPLAY_TYPE_BUTTON, INTERACTION_DISPLAY_TYPE_ICON } from '../../constants';
import './WebsiteComponentInteraction.css';
var defaultProps = {
  className: '',
  content: '',
  children: null,
  displayComponentPropsMap: (_displayComponentProp = {}, _defineProperty(_displayComponentProp, INTERACTION_DISPLAY_TYPE_BUTTON, {
    size: 'tiny',
    compact: true
  }), _defineProperty(_displayComponentProp, INTERACTION_DISPLAY_TYPE_ICON, {}), _displayComponentProp),
  event: null
};
function WebsiteComponentInteraction(_ref) {
  var interaction = _ref.interaction,
    className = _ref.className,
    content = _ref.content,
    children = _ref.children,
    displayComponentPropsMap = _ref.displayComponentPropsMap,
    event = _ref.event;
  var label = interaction.label,
    enabled = interaction.enabled;
  if (!enabled) {
    return null;
  }
  var displayComponentProps = getDisplayComponentProps({
    interaction: interaction,
    displayComponentPropsMap: displayComponentPropsMap,
    className: className,
    event: event
  });
  var DisplayComponent = getDisplayComponent(interaction);
  return /*#__PURE__*/React.cloneElement(DisplayComponent, _objectSpread(_objectSpread({}, displayComponentProps), {}, {
    children: children || content || label || DEFAULT_LABEL
  }));
}
WebsiteComponentInteraction.defaultProps = defaultProps;
export default WebsiteComponentInteraction;